const Commune = () => {
    return (  
        <div className="Commune">Gestion commune</div>
    );
}
 
export default Commune;